import PlaneAction from "./PlaneAction.js";
import {refuel} from "../planeSlice.js";
import { FUEL_MAX_QTY } from "../../assets/virtual-flyout/perf-calc.js";
import { isFuelAvailable } from "../../assets/virtual-flyout/airport-service.js";
export default class Refuel extends PlaneAction {
    constructor(planeId, airport, fuelType, fuelQty) {
        super(planeId);
        this.airport = airport;
        this.fuelType = fuelType;
        this.fuelQty = fuelQty;
    }

    execute() {
        if (isFuelAvailable(this.airport.code, this.fuelType)) {
            const plane = this.getState();
            const maxFuelQty = FUEL_MAX_QTY[plane.type];
            if (this.fuelQty > maxFuelQty) {
                this.fuelQty = maxFuelQty;
            }
            this.log(`Refuelling to ${this.fuelQty} gallons`);
            this.dispatch(refuel({fuel: this.fuelQty}));
        } else {
            this.log(`${this.fuelType} not available at ${this.airport}`);
        }
    }

    isComplete = () => true;
}

